import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Note: StrictMode removed to prevent double API calls in development
// React StrictMode intentionally double-invokes effects to help find bugs,
// but this causes duplicate API calls which wastes resources.
// In production, this doesn't happen regardless.
root.render(
  <App />
);